import React, { useContext, useEffect, useState } from "react";
import { patientService } from "../../services/patient.service";
import AuthContext from "../../store/auth-context";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import Carousel from "react-bootstrap/Carousel";
import axios from "axios";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UpcomingAppointmentsCard = () => {
  const [t] = useTranslation();
  const authCtx = useContext(AuthContext);
  const history = useHistory();
  //const [patientIdHISList, setPatientIdHISList] = useState<any>([]);
  //const [patientIdList, setPatientIdList] = useState<any>([]);

  const [upcomingAppt, setUpcomingAppts] = useState<any>([]);
  const [slideIndex, setSlideIndex] = useState<any>(0);
  const [slideTotalCount, setSlideTotalCount] = useState<any>(0);
  //const [familyMemberId, setFamilyMemberId] = useState<any>(0);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const userData = JSON.parse(localStorage.getItem("user") || "{}");
  const brandName = (localStorage.getItem("brandName") || "")
    .toLowerCase()
    .trim();
  const appConfiguration = JSON.parse(
    localStorage.getItem("appConfiguration") || "{}"
  );

  useEffect(() => {
    const isBmc = brandName === "bmc";
    const canLoadAppointments =
      userData.isDOBAvailable &&
      userData.facilityId &&
      (isBmc || authCtx.locationGlobalList.length > 0);

    if (canLoadAppointments) {
      getPatientRec();
    }

    return () => {
      setUpcomingAppts([]);
    };

    // eslint-disable-next-line
  }, [authCtx.isDobAvailable, authCtx.locationGlobalList]);

  const handleModelClose = () => setShowModal(false);

  const getPatientRec = async () => {
    authCtx.toggleLoader(true);
    setUpcomingAppts([]);
    authCtx.setConsultedDoctorList([]);
    const currentHis: any = authCtx.locationGlobalList.find(
      (item: any) => item.locationId === userData.facilityId
    );
    const patientRecord = JSON.parse(
      localStorage.getItem("getPatientRecord") || "{}"
    );
    const isPatientRecordCall = localStorage.getItem("isPatientRecordCall");
    if (
      Object.keys(patientRecord).length !== 0 &&
      isPatientRecordCall === "true"
    ) {
      getApptHistory(patientRecord);
    } else {
      let userData = JSON.parse(localStorage.getItem("user") || "{}");
      let res = await patientService.getPatientRec(
        userData.userId,
        0,
        userData.facilityId
      );
      let idList = res && res.data ? res.data : [];
      let patientIdHISList: any = [];
      if (res && res.data === undefined) {
        console.log(t("Something went wrong!"));
      } else if (res && res.status && res.status === 500) {
        console.log("Internal Server Error");
      } else {
        //setPatientIdList(idList);
        idList.forEach((item: any) => {
          if (
            item &&
            (item.patientId !== null || (item.mobileNo && item.mobileNo !== ""))
          ) {
            if (patientIdHISList.length > 0) {
              if (patientIdHISList.some((obj: any) => obj.his === item.his)) {
                patientIdHISList.forEach((item2: any) => {
                  if (
                    item2.his === item.his &&
                    item2.patientId !== item.patientId
                  ) {
                    item2.patientId = [...item2.patientId, item.patientId];
                  }
                });
              } else {
                let data = {
                  his: item.his,
                  patientId: [item.patientId],
                  mobileNo: item.mobileNo,
                };
                patientIdHISList.push(data);
              }
            } else {
              let data = {
                his: item.his,
                patientId: [item.patientId],
                mobileNo: item.mobileNo,
              };
              patientIdHISList.push(data);
            }
          }
        });
      }

      if (patientIdHISList.length > 0) {
        localStorage.setItem(
          "getPatientRecord",
          JSON.stringify(patientIdHISList)
        );
        localStorage.setItem("isPatientRecordCall", "true");
        getApptHistory(patientIdHISList);
      }
    }
    authCtx.toggleLoader(false);
  };

  const getApptHistory = async (idList: any) => {
    authCtx.toggleLoader(true);
    const upcomingAppointmentsArr: any[] = [];
    const consultedDoctorList: any[] = [];

    await Promise.all(
      idList.map(async (item: any) => {
        if (!item?.patientId?.[0]) {
          return;
        }
        const response = await patientService.apptHistory(item);
        if (
          response &&
          response.message &&
          response.message.status &&
          (response.message.status[0] === "S" ||
            response.message.status[0] === "Success")
        ) {
          const upcoming = (response.upcomingAppts || []).map((prop: any) =>
            prop.patientId === null || prop.patientId === ""
              ? { ...prop, patientId: item.patientId[0], mobileNo: item.mobileNo }
              : { ...prop, mobileNo: item.mobileNo }
          );
          upcomingAppointmentsArr.push(...upcoming);
          consultedDoctorList.push(...(response.consultedDoctors || []));
        }
      })
    );

    if (upcomingAppointmentsArr.length > 0) {
      let filterdAppointment;
      if (
        userData.facilityId &&
        appConfiguration.filterToBeApplied
      ) {
        filterdAppointment = upcomingAppointmentsArr.filter(
          (appt: any) =>
            appt.facilityId === userData.facilityId &&
            appt.scheduleType !== "TELEMED"
        );
      } else {
        filterdAppointment = upcomingAppointmentsArr.filter(
          (appt: any) => appt.scheduleType !== "TELEMED"
        );
      }
      setUpcomingAppts(filterdAppointment);
      setSlideTotalCount(filterdAppointment.length);
    } else {
      setUpcomingAppts([]);
    }

    if (consultedDoctorList.length > 0) {
      let filterdConsultedDoc;
      if (
        userData.facilityId &&
        appConfiguration.filterToBeApplied
      ) {
        filterdConsultedDoc = consultedDoctorList.filter(
          (doc: any) => doc.locationId === userData.facilityId
        );
      } else {
        filterdConsultedDoc = consultedDoctorList;
      }
      authCtx.setConsultedDoctorList(filterdConsultedDoc);
    } else {
      authCtx.setConsultedDoctorList([]);
    }

    authCtx.toggleLoader(false);
  };

  const handleSlideIndex = (slideIndex: any) => {
    setSlideIndex(slideIndex + 1);
  };

  return (
    <>
      <div className="card border-0 shadow-sm rounded-1rem mb-4 position-relative">
        <div className="card-body p-4 ">
          <h6 className="fw-bold text-primary">{t("Upcoming Appointments")}</h6>
          <Carousel
            controls={false}
            fade
            interval={3000}
            pause={"hover"}
            slide={true}
            variant={"dark"}
            indicators={false}
            nextLabel={"Next"}
            onSelect={(e) => handleSlideIndex(e)}
          >
            {upcomingAppt !== undefined &&
              upcomingAppt.length > 0 &&
              upcomingAppt.map((item: any, index: any) =>
                item ? (
                  <Carousel.Item key={index}>
                    <div className="d-flex mt-3 align-items-center">
                      <div className="flex-shrink-0">
                        <img
                          src={
                            item && item.image
                              ? item.image
                              : "/assets/images/doc.png"
                          }
                          className="img-57 rounded-circle dr-photo"
                          alt=""
                        />
                      </div>

                      <div className="flex-grow-1 ms-3">
                        <label className="fw-bold">
                          {item && item.physicianName
                            ? item.physicianName
                            : null}
                        </label>
                        {item.scheduleType === "TELEMED" ? (
                          <div>
                            <Link
                              className="btn btn-primary no-focus btn-sm mt-1"
                              to="/auth/teleconsultationAppointments"
                            >
                              {t("Start Teleconsultation")}
                            </Link>
                          </div>
                        ) : (
                          <>
                            <p className="text-muted text-truncate upcommimg-speciality-wrap fs-12 m-0">
                              {item && item.specialty ? item.specialty : null}
                            </p>
                            <p className="text-muted fs-12 m-0">
                              {item && item.location ? item.location : null}
                            </p>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="d-flex">
                      {item && item.apptTime && item.apptDate ? (
                        <p className="mt-3 mb-0" dir="ltr">
                          {new Date(
                            "1970-01-01T" + item.apptTime + "Z"
                          ).toLocaleTimeString("en-US", {
                            timeZone: "UTC",
                            hour12: true,
                            hour: "numeric",
                            minute: "numeric",
                          })}
                          |
                          {item && item.apptDate
                            ? new Date(item.apptDate).toDateString()
                            : null}
                        </p>
                      ) : null}
                      <p className="ms-auto mt-3 mb-0">
                        {" "}
                        {slideIndex}/{slideTotalCount}
                      </p>
                    </div>
                  </Carousel.Item>
                ) : (
                  <Carousel.Item key={index}>
                    <div className="mh-240p d-flex justify-content-center align-items-center">
                      <div className="text-center text-999 mt-4">
                        {" "}
                        <i className="material-icons-outlined fs-1"> info </i>
                        <p className="fs-6">{t("No Upcoming Appointments")}</p>
                      </div>
                    </div>
                  </Carousel.Item>
                )
              )}
          </Carousel>
          {upcomingAppt && upcomingAppt.length === 0 && (
            <div className="mh-240p d-flex justify-content-center align-items-center">
              <div className="text-center text-999 mt-4">
                {" "}
                <i className="material-icons-outlined fs-1"> info </i>
                <p className="fs-6">{t("No Upcoming Appointments")}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleModelClose}
        >
          <Alert onClose={handleModelClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default UpcomingAppointmentsCard;
